import { Component } from 'preact';
import ClassNames from "classnames";
import { DELIVERY_TYPES } from "../../constants/constants";
import TextWrapper from "../../util/wrapper/TextWrapper";
import { findMinPrice, formatRawPrice } from "../../util/CurrencyUtils";
import {fillTemplate, getCurrentTranslation} from "../../../i18n/I18nResolver";
import { hasOptionWithGreenDate } from "../../util/GreenChoiceUtils";
import {handleTabArrowKeyPress} from "../../util/KeyboardNavigationUtils";

export default class TypeNavigation extends Component {

    constructor(props) {
        super(props);
    }

    showEstimatedDate = () => {
        const {onSelectType} = this.props;
        onSelectType(DELIVERY_TYPES.ESTIMATED_DATE);
    };

    showExactDate = () => {
        const {onSelectType} = this.props;
        onSelectType(DELIVERY_TYPES.EXACT_DATE);
    };

    handleKeyDown = (e) => {
        const {selectedType, onSelectType} = this.props;
        const ESTIMATED_BUTTON_ID = `type-picker__btn--0`;
        const EXACT_BUTTON_ID = `type-picker__btn--1`;
        const TAB_SELECTOR = `[role="tab"][id^="type-picker__btn--"]`;

        const result = handleTabArrowKeyPress(
            e,
            selectedType === DELIVERY_TYPES.ESTIMATED_DATE ? ESTIMATED_BUTTON_ID : EXACT_BUTTON_ID,
            TAB_SELECTOR
        );

        if (!result) {
            return;
        }

        result.nextTabElement.focus();

        const nextType = result.nextTabId === ESTIMATED_BUTTON_ID ?
            DELIVERY_TYPES.ESTIMATED_DATE : DELIVERY_TYPES.EXACT_DATE;
        onSelectType(nextType);
    };

    getGreenChoiceTitle(exactDateMinPrice, fields) {
        const translation = getCurrentTranslation();

        const exactDateLowestPrice = translation.common.fromZeroValue && !exactDateMinPrice ?
            translation.common.fromZeroValue : translation.common.fromValue;
        const exactDateLowestPriceText = fillTemplate(exactDateLowestPrice, fields);

        return exactDateLowestPriceText + '. ' + translation.greenChoice.gcOptionsAvailable + '. ' + translation.greenChoice.description;
    }

    render() {
        const {selectedType, exactDateOptions, estimatedDateOptions, config} = this.props;

        const isEstimatedDateSelected = DELIVERY_TYPES.ESTIMATED_DATE === selectedType;
        const isExactDateSelected = DELIVERY_TYPES.EXACT_DATE === selectedType;

        const estimatedDateClassName = ClassNames(
            "tabs__navigation__tab type-select__tab tab",
            {"tab--selected": isEstimatedDateSelected}
        );

        const exactDateClassName = ClassNames(
            "tabs__navigation__tab type-select__tab tab",
            {"tab--selected": isExactDateSelected}
        );

        const hasExactDateOptions = exactDateOptions && exactDateOptions.length > 0;
        const hasEstimatedDateOptions = estimatedDateOptions && estimatedDateOptions.length > 0;

        const navigationClassName = ClassNames(
            "tabs__navigation type-select__navigation",
            {"hidden": !hasExactDateOptions || !hasEstimatedDateOptions}
        );

        const greenDatesPresent = hasExactDateOptions && hasOptionWithGreenDate(exactDateOptions);

        const translation = getCurrentTranslation();

        let estimatedDateMinPrice = findMinPrice(estimatedDateOptions);
        const estimatedDateLowestPriceTextId = translation.common.fromZeroValue && !estimatedDateMinPrice ? "common.fromZeroValue" : "common.fromValue";

        let exactDateMinPrice = findMinPrice(exactDateOptions);
        const exactDateLowestPriceTextId = translation.common.fromZeroValue && !exactDateMinPrice ? "common.fromZeroValue" : "common.fromValue";
        const fields = {lowestPrice: formatRawPrice(exactDateMinPrice, config)};

        return (
            <nav className={navigationClassName} role="tablist">
                <ul className="tabs__navigation__listing type-select__listing" role="presentation">
                    <li className="tabs__navigation__item type-select__item" role="presentation">
                        <button type="button"
                                className={estimatedDateClassName}
                                onClick={this.showEstimatedDate}
                                role="tab"
                                id="type-picker__btn--0"
                                aria-controls="type-picker__panel--0"
                                aria-selected={isEstimatedDateSelected}
                                tabIndex={isEstimatedDateSelected ? 0 : -1}
                                onKeyDown={this.handleKeyDown}>

                            <span className="paazl-delimiter">
                                <TextWrapper id="tabs.estimatedDate" additionalClassName="tab__title"/>

                                {
                                    config.isPricingEnabled &&
                                    <span className="tab__date">
                                        <TextWrapper id={estimatedDateLowestPriceTextId}
                                                     fields={{lowestPrice: formatRawPrice(estimatedDateMinPrice, config)}}
                                                     capitalize/>
                                    </span>
                                }
                            </span>
                        </button>
                    </li>

                    <li className="tabs__navigation__item type-select__item" role="presentation">
                        <button type="button"
                                className={exactDateClassName}
                                onClick={this.showExactDate}
                                role="tab"
                                id="type-picker__btn--1"
                                aria-controls="type-picker__panel--1"
                                aria-selected={isExactDateSelected}
                                tabIndex={isExactDateSelected ? 0 : -1}
                                onKeyDown={this.handleKeyDown}>

                            <span className="paazl-delimiter">
                                {
                                    greenDatesPresent &&
                                    <div className={'tab__title-and-icon--gc'}>
                                        <div className={'tab__title-wrapper'}>
                                            <div className={'tab__title-name--gc'}>
                                                <TextWrapper id="tabs.exactDate"
                                                             additionalClassName={"tab__title"}/>
                                            </div>
                                            <div className={'tab__title-icon--gc'}>
                                                <span/>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    !greenDatesPresent &&
                                    <TextWrapper id="tabs.exactDate" additionalClassName="tab__title"/>
                                }

                                {
                                    config.isPricingEnabled &&
                                    <span className="tab__date">
                                        <TextWrapper id={exactDateLowestPriceTextId}
                                                     ariaLabel={greenDatesPresent ? this.getGreenChoiceTitle(exactDateMinPrice, fields) : null} // React will omit the attribute if the value is null
                                                     fields={fields}
                                                     capitalize/>
                                    </span>
                                }
                            </span>
                        </button>
                    </li>
                </ul>
            </nav>
        );
    }
}